import type { NavigationGuard } from "vue-router";
import authService from "./authService";
import _ from "lodash";
import { useUserStore } from "@/store/useUserStore";

export const authGuard: NavigationGuard = async (to, from, next) => {
  const token = authService.getToken();

  let pages: any[] = [];
  const userStore = useUserStore();
  if (token && (!userStore.userPages || userStore.userPages.length === 0)) {
    await userStore.ensurePagesLoaded();
  }

  const flattenPages = (pageList: any[]): any[] => {
    let result: any[] = [];
    pageList.forEach((page) => {
      result.push(page);
      if (page.childs && page.childs.length > 0) {
        result = result.concat(flattenPages(page.childs));
      }
    });
    return result;
  };

  if (userStore.userPages && userStore.userPages.length > 0) {
    pages = flattenPages(userStore.userPages);
  }

  if (!token) {
    next("/login");
  }
  //extraUrl is comma separated list of urls that also have access to the page
  if (
    (pages && (_.map(pages, (i) => i.pageUrl).includes(to.path) || _.some(pages, (i) => i.extraUrl?.split(',').includes(to.path)))) ||
    to.path == "/home"
  ) {
    next();
  }
  else {
    next("/access-denied");
  }

};
